const data = [
    {
		id: '1',
		customer_name: 'Tomas',
        customer_lastname: 'Cerezo Ramirez',
		customer_id: '744',
		date: '2022-05-17T03:24:00',
		credits: '£10.00',
	},
	{
		id: '2',
		customer_name: 'Tomas',
        customer_lastname: 'Liger Pertiga',
		customer_id: '745',
		date: '2022-05-17T03:24:00',
		credits: '£10.00',
	},
	{
		id: '3',
		customer_name: 'Fernando',
        customer_lastname: 'Perez Perez',
		customer_id: '746',
		date: '2022-05-17T03:24:00',
		credits: '£10.00',
	},
	{
		id: '4',
		customer_name: 'Fernando',
        customer_lastname: 'Cabello Velazque',
		customer_id: '747',
		date: '2022-05-17T03:24:00',
		credits: '£10.00',
	},
	{
		id: '5',
		customer_name: 'Maria',
        customer_lastname: 'Ruiz Ardila',
		customer_id: '748',
		date: '2022-05-17T03:24:00',
		credits: '£10.00',
	},
	{
		id: '6',
		customer_name: 'Maria',
        customer_lastname: 'Delgado Delgado',
		customer_id: '749',
		date: '2022-05-17T03:24:00',
		credits: '£10.00',
	},
]

export default data;